module.exports = __webpack_public_path__ + "img/pdf_bg_results_2.92ef5f20.png";